import { useRouter } from 'next/router';

const useIsBettingSection = () => {
    const router = useRouter();
    // Verificamos si router está listo para evitar errores en SSR/hidratación inicial si es necesario,
    // aunque pathname suele estar disponible.
    return router.pathname?.includes('apuestas-deportivas') || false;
};

export default useIsBettingSection;
